import React from "react";
import Header from "../../components/Header";
import "./style.css";

const Terms = () => (
  <div className="terms-page">
    <Header activePath="" />
    <div className="terms-content">
      <iframe
        src="https://cdn-www.hui51.cn/terms.html"
        title="用户协议"
        className="terms-iframe"
      />
    </div>
  </div>
);

export default Terms;
